import { render, staticRenderFns } from "./PriceTableHeader.vue?vue&type=template&id=5bfd54c9&scoped=true&"
import script from "./PriceTableHeader.vue?vue&type=script&lang=js&"
export * from "./PriceTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./PriceTableHeader.vue?vue&type=style&index=0&id=5bfd54c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd54c9",
  null
  
)

export default component.exports